export const buildDateRangeFacetKey = ({
  before,
  after,
}: {
  before: string;
  after: string;
}) => {
  return `${before}:${after}`;
};
